import ApiService from "@/core/services/api.service";

export default {
  select (query = {}) {
    return ApiService.query('contractor/messages', query)
  },
  send (data = {}) {
    return ApiService.post('contractor/messages', data)
  },
  markReaded(id) {
    return ApiService.post(`contractor/messages/${id}/mark_readed`)
  }
}
